import React from 'react';
import { Menubar } from 'primereact/menubar';
import { Routes, Route, useNavigate } from 'react-router-dom';
// import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '/node_modules/primeflex/primeflex.css'
import './theme.css';
// Import pages
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import WhyUs from './pages/WhyUs';
import Services from './pages/Services';
import BusinessAdvisory from './pages/services/BusinessAdvisory';
import DueDiligence from './pages/services/DueDiligence';
import TaxAdvisory from './pages/services/TaxAdvisory';
import RiskManagement from './pages/services/RiskManagement';
import LegalCompliance from './pages/services/LegalCompliance';
import AccountingServices from './pages/services/AccountingServices';
import SchoolManagement from './pages/services/SchoolManagement';
import Blog from './pages/Blog';
import NotFound from './pages/NotFound';
import ProjectFinancing from './pages/services/ProjectFinancing';
import ERPCustomization from './pages/services/ERPCustomization';
import LegalDueDiligence from './pages/services/LegalDueDiligence';
import FinancialDueDiligence from './pages/services/FinancialDueDiligence';
import OperationalDueDiligence from './pages/services/OperationalDueDiligence ';
import TaxDueDiligence from './pages/services/TaxDueDiligence';
import CommercialDueDiligence from './pages/services/CommercialDueDiligence';
import LegalRegulatoryCompliance from './pages/services/LegalRegulatoryCompliance ';
import OutsourcedAccounting from './pages/services/OutsourcedAccounting';
import StartNewSchool from './pages/services/StartNewSchool';
import SchoolOperations from './pages/services/SchoolOperations';
import SchoolValuation from './pages/services/SchoolValuation';
import { Button } from 'primereact/button';
import ForensicAccounting from './pages/services/ForensicAccounting';
import BusinessSetUp from './pages/services/BusinessSetUp';
import Contact from './pages/Contact';

const App = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      label: "Home",
      command: () => navigate("/")
    },
    {
      label: "About Us",
      command: () => navigate("/about")
    },
    {
      label: "Why Us",
      command: () => navigate("/why-us")
    },
    {
      label: "Our Services",
      items: [
        {
          label: "Business Advisory",
          items: [
            { label: "Project Financing", command: () => navigate("/services/project-financing") },
            { label: "Customising & Maintenance of ERP", command: () => navigate("/services/erp-customization") }
          ]
        },
        {
          label: "Due Diligence",
          items: [
            { label: "Legal Due Diligence", command: () => navigate("/services/legal-due-diligence") },
            { label: "Financial Due Diligence", command: () => navigate("/services/financial-due-diligence") },
            { label: "Operational Due Diligence", command: () => navigate("/services/operational-due-diligence") },
            { label: "Tax Due Diligence", command: () => navigate("/services/tax-due-diligence") },
            { label: "Commercial Due Diligence", command: () => navigate("/services/commercial-due-diligence") }
          ]
        },
        {
          label: "Tax Advisory", command: () => navigate("/services/tax-advisory")
          // items: [
          //   { label: "Income Tax Compliance & Litigation", command: () => navigate("/services/income-tax") },
          //   { label: "Tax Structuring & Tax Planning", command: () => navigate("/services/tax-structuring") },
          //   { label: "GST Compliance & Litigation", command: () => navigate("/services/gst-compliance") },
          //   { label: "Transfer Pricing", command: () => navigate("/services/transfer-pricing") }
          // ]
        },
        {
          label: "Risk Management", command: () => navigate("/services/risk-management")
          // items: [
          //   { label: "Internal Audit", command: () => navigate("/services/internal-audit") },
          //   { label: "Design & Implementation of SOP", command: () => navigate("/services/sop-implementation") },
          //   { label: "Inventory Management & Stock Verification", command: () => navigate("/services/inventory-management") }
          // ]
        },
        {
          label: "Business Set Up Services", command: () => navigate("/services/business-set-up")
        },
        {
          label: "Legal & Regulatory Compliance", command: () => navigate("/services/legal-regulatory-compliance")
        },
        {
          label: "Forensic Accounting & Fraud Detection", command: () => navigate("/services/forensic-accounting")
        },
        // {
        //   label: "Legal & Regulatory Compliance",
        //   items: [
        //     { label: "Corporate Law", command: () => navigate("/services/corporate-law") },
        //     { label: "FEMA", command: () => navigate("/services/fema-compliance") }
        //   ]
        // },
        {
          label: "Outsourced Accounting Services", command: () => navigate("/services/outsourced-accounting-services")
          // items: [
          //   { label: "Accounting & Book Keeping", command: () => navigate("/services/bookkeeping") },
          //   { label: "Invoice Processing", command: () => navigate("/services/invoice-processing") },
          //   { label: "Payroll", command: () => navigate("/services/payroll") },
          //   { label: "Ind AS & IFRS Implementation & Consolidation", command: () => navigate("/services/ifrs-implementation") }
          // ]
        },
        {
          label: "School Management Services",
          items: [
            { label: "Starting a New School", command: () => navigate("/services/starting-new-school") },
            { label: "School Operations & Development", command: () => navigate("/services/school-operations") },
            { label: "Valuation & Acquisition Services", command: () => navigate("/services/valuation-acquisition") }
          ]
        }
      ],
      // command: () => navigate("/services")
    },
    // {
    //   label: "Blogs",
    //   command: () => navigate("/blog")
    // },
    {
      label: "Contact",
      command: () => navigate("/contact")
    },
  ];

  return (
    <div className="app">
      <div className="flex py-3 px-6 shadow-2 flex align-items-center justify-content-between relative lg:static">
        <a href="/">
        <img src="/snpfull.png" alt="Image" width={250} className='w-6' /> </a>
        <div className="flex-grow-1 lg:flex lg:static w-full  lg:px-0 z-2 ">
          <Menubar model={menuItems} className="p-menubar w-full"  />
          {/* <div className="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
            <Button label="Login" className="p-button-text font-bold" />
            <Button label="Get A Quote" className="p-button-outlined font-bold ml-3 border-round-lg bg-primary text-white" />
          </div> */}
        </div>
      </div>
      <div className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/why-us" element={<WhyUs />} />

          {/* Services Routes */}
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/services/business-advisory" element={<BusinessAdvisory />} />
          <Route path="/services/due-diligence" element={<DueDiligence />} />
          <Route path="/services/tax-advisory" element={<TaxAdvisory />} />
          <Route path="/services/risk-management" element={<RiskManagement />} />
          <Route path="/services/legal-compliance" element={<LegalCompliance />} />
          <Route path="/services/accounting" element={<AccountingServices />} />
          <Route path="/services/school-management" element={<SchoolManagement />} />

          {/* Sub-service routes */}
          <Route path="/services/project-financing" element={<ProjectFinancing />} />
          <Route path="/services/erp-customization" element={<ERPCustomization />} />
          {/* Add all other sub-service routes here */}
          <Route path="/services/legal-due-diligence" element={<LegalDueDiligence />} />
          <Route path="/services/financial-due-diligence" element={<FinancialDueDiligence />} />
          <Route path="/services/operational-due-diligence" element={<OperationalDueDiligence />} />
          <Route path="/services/tax-due-diligence" element={<TaxDueDiligence />} />
          <Route path="/services/commercial-due-diligence" element={<CommercialDueDiligence />} />
          <Route path="/services/legal-regulatory-compliance" element={<LegalRegulatoryCompliance />} />
          <Route path="/services/outsourced-accounting-services" element={<OutsourcedAccounting />} />
          <Route path="/services/starting-new-school" element={<StartNewSchool />} />
          <Route path="/services/school-operations" element={<SchoolOperations />} />
          <Route path="/services/valuation-acquisition" element={<SchoolValuation />} />
          <Route path="/services/tax-advisory" element={<TaxAdvisory />} />
          <Route path="/services/risk-management" element={<RiskManagement />} />
          <Route path="/services/forensic-accounting" element={<ForensicAccounting />} />
          <Route path="/services/business-set-up" element={<BusinessSetUp />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
